
import { defineComponent, PropType } from "vue";

const HIDDEN_BINARY_FIELDS = new Set([
  "imageAsBase64",
  "imageAsByteString",
  "fingerprint",
  "fingerPrint"
]);

const FIELD_LABELS: Record<string, string> = {
  result: "Үр дүн",
  resultcode: "Үр дүнгийн код",
  service: "Сервис",
  data: "Мэдээлэл",
  list: "Жагсаалт",
  regnum: "Регистрийн дугаар",
  register: "Регистрийн дугаар",
  civilId: "Иргэний хувийн дугаар",
  surName: "Ургийн овог",
  surname: "Ургийн овог",
  lastName: "Овог",
  lastname: "Овог",
  firstName: "Нэр",
  firstname: "Нэр",
  gender: "Хүйс",
  birthDate: "Төрсөн огноо",
  birthPlace: "Төрсөн газар",
  nationality: "Үндэс угсаа",
  country: "Улс",
  countryName: "Улс",
  isMarried: "Гэрлэсэн эсэх",
  marriageStatus: "Гэрлэлтийн төлөв",
  registeredDate: "Бүртгэсэн огноо",
  registeredCity: "Бүртгэсэн хот",
  registeredDistrict: "Бүртгэсэн дүүрэг",
  father: "Эцгийн мэдээлэл",
  mother: "Эхийн мэдээлэл",
  husband: "Нөхрийн мэдээлэл",
  wife: "Эхнэрийн мэдээлэл",
  address: "Хаягийн мэдээлэл",
  ownerAddress: "Эзэмшигчийн хаяг",
  passportAddress: "Иргэний үнэмлэх дээрх хаяг",
  addressDetail: "Хаягийн дэлгэрэнгүй",
  addressDetial: "Хаягийн дэлгэрэнгүй",
  addressStreetName: "Гудамж",
  addressRegionName: "Хороолол",
  addressTownName: "Хотхон",
  addressApartmentName: "Байр",
  aimagCityName: "Аймаг, хот",
  soumDistrictName: "Сум, дүүрэг",
  bagKhorooName: "Баг, хороо",
  companyRegnum: "Компанийн регистр",
  stateRegnum: "Улсын бүртгэлийн дугаар",
  companyName: "Хуулийн этгээдийн нэр",
  ownershipTypeName: "Өмчлөлийн төрөл",
  profitTypeName: "Ашгийн төрөл",
  general: "Ерөнхий мэдээлэл",
  liquidation: "Татан буугдсан мэдээлэл",
  branch: "Салбарын мэдээлэл",
  capital: "Хөрөнгийн мэдээлэл",
  founder: "Үүсгэн байгуулагч",
  generalR: "Удирдлагын мэдээлэл",
  induty: "Үйл ажиллагааны мэдээлэл",
  shareHolders: "Хувьцаа эзэмшигчид",
  stakeHolders: "Оролцогчид",
  plateNumber: "Улсын дугаар",
  plateNo: "Улсын дугаар",
  cabinNumber: "Арлын дугаар",
  cabinNo: "Арлын дугаар",
  certificateNumber: "Гэрчилгээний дугаар",
  certificateNo: "Гэрчилгээний дугаар",
  markName: "Марк",
  modelName: "Загвар",
  buildYear: "Үйлдвэрлэсэн он",
  buildMonth: "Үйлдвэрлэсэн сар",
  colorName: "Өнгө",
  fueltype: "Шатахуун",
  fualName: "Шатахуун",
  ownerType: "Эзэмшигчийн төрөл",
  ownerFirstname: "Эзэмшигчийн нэр",
  ownerLastname: "Эзэмшигчийн овог",
  ownerRegnum: "Эзэмшигчийн регистр",
  holder: "Эзэмшигч",
  status: "Төлөв",
  statusName: "Төлөв",
  createdDate: "Үүсгэсэн огноо",
  updatedDate: "Шинэчилсэн огноо",
  importDate: "Импортолсон огноо",
  archiveDate: "Архивласан огноо",
  phoneNumber: "Утасны дугаар",
  mobileNumber: "Гар утас",
  email: "И-мэйл",
  startYear: "Эхлэх он",
  endYear: "Дуусах он",
  getYear: "Он",
  getMonth: "Сар",
  getOrgName: "Байгууллага",
  getSalaryAmount: "Цалингийн дүн",
  getSalaryFee: "Шимтгэлийн дүн",
  isPaid: "Төлөгдсөн эсэх",
  institutionName: "Сургуулийн нэр",
  programName: "Хөтөлбөр",
  degreeName: "Зэрэг",
  dergeeName: "Зэрэг",
  conferYear: "Төгссөн он",
  decisionDate: "Шийдвэрийн огноо",
  decisionNumber: "Шийдвэрийн дугаар",
  totalAmount: "Нийт дүн",
  sharePercent: "Эзэмшлийн хувь",
  purposeName: "Зориулалт",
  type: "Төрөл",
  className: "Ангилал",
  capacity: "Багтаамж",
  mass: "Жин",
  weight: "Жин",
  height: "Өндөр",
  width: "Өргөн",
  length: "Урт"
};

export default defineComponent({
  name: "XypValueRenderer",
  props: {
    value: {
      type: [Object, Array, String, Number, Boolean] as PropType<any>,
      default: null
    }
  },
  methods: {
    isObject(value: any): value is Record<string, any> {
      return (
        value !== null && typeof value === "object" && !Array.isArray(value)
      );
    },
    isPrimitive(value: any): boolean {
      return !this.isObject(value) && !Array.isArray(value);
    },
    visibleEntries(value: Record<string, any>): Array<[string, any]> {
      return Object.entries(value || {}).filter(
        ([key]) => !HIDDEN_BINARY_FIELDS.has(key)
      );
    },
    simpleEntries(value: Record<string, any>): Array<[string, any]> {
      return this.visibleEntries(value).filter(([, item]) =>
        this.isPrimitive(item)
      );
    },
    complexEntries(value: Record<string, any>): Array<[string, any]> {
      return this.visibleEntries(value).filter(
        ([, item]) => this.isObject(item) || Array.isArray(item)
      );
    },
    isFlatObjectArray(value: any[]): boolean {
      return (
        value.length > 0 &&
        value.every(
          row =>
            this.isObject(row) &&
            this.visibleEntries(row).every(([, item]) => this.isPrimitive(item))
        )
      );
    },
    tableColumns(rows: Array<Record<string, any>>): string[] {
      const keys = new Set<string>();
      rows.forEach(row => {
        this.visibleEntries(row).forEach(([key]) => keys.add(key));
      });
      return Array.from(keys);
    },
    formatKey(key: string): string {
      if (FIELD_LABELS[key]) return FIELD_LABELS[key];
      const readable = key
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/_/g, " ")
        .trim();
      return readable.charAt(0).toUpperCase() + readable.slice(1);
    },
    sectionTitle(key: string): string {
      return FIELD_LABELS[key] || this.formatKey(key);
    },
    formatValue(value: any): string {
      if (value === null || value === undefined || value === "") return "—";
      if (typeof value === "boolean") return value ? "Тийм" : "Үгүй";
      if (Array.isArray(value)) return `${value.length} мөр`;
      if (this.isObject(value)) return "Дэлгэрэнгүй мэдээлэл";
      const text = String(value);
      const isoDate = /^(\d{4})-(\d{2})-(\d{2})T/.exec(text);
      return isoDate ? `${isoDate[1]}-${isoDate[2]}-${isoDate[3]}` : text;
    },
    valueClass(value: any): string {
      if (typeof value === "boolean") {
        return value ? "xyp-value--yes" : "xyp-value--no";
      }
      return "";
    },
    isLongValue(value: any): boolean {
      return typeof value === "string" && value.length > 80;
    }
  }
});
